<template>
    <settings-wrapper title="User settings" section="Secrets">
        <secrets-listing :level="0" />
    </settings-wrapper>
</template>

<script>
import SettingsWrapper from '@/components/SettingsWrapper.vue'
const SecretsListing = () => import('@/components/SecretsListing.vue')

export default {
    name: 'UserSettingsSecrets',
    components: {
        SettingsWrapper,
        SecretsListing
    }
}
</script>
